import React from 'react';
import { Alert } from 'reactstrap';
import ExternalLink from '~/components/ExternalLink';
import { getAppContext } from '~/lib/AppContext';

type AccountRestrictionAlertProps = {
    children: React.ReactNode;
    className?: string;
    innerRef?: React.Ref<HTMLDivElement>;
};

export default function AccountRestrictionAlert({ children, className, innerRef }: AccountRestrictionAlertProps) {
    return (
        <Alert color="warning" className={className} innerRef={innerRef}>
            <i className="icon ion-md-alert my-2 p-1"></i> {children} Please{' '}
            <ExternalLink href={getAppContext().config.supportSite} className="alert-link">
                contact {getAppContext().config.brandName} support
            </ExternalLink>{' '}
            if you require an update on your account verification process. Note it can take up to 72 hours for an
            account to be verified.
        </Alert>
    );
}
